import { renderIsomorphicComponent, renderComponent } from "@quintype/framework/client/start";
// import {  renderBreakingNews } from "@quintype/framework/client/start";
import get from "lodash/get";

import { pickComponent } from "../isomorphic/pick-component";
import { PAGE_TYPE } from "../isomorphic/constants";
// import { BreakingNewsView } from "../isomorphic/components/breaking-news-view";
import { Footer } from "../isomorphic/components/layouts/footer";
// import { NavbarSearch } from "../isomorphic/components/layouts/header/navbar-search";
import { Header } from "./../isomorphic/components/layouts/header";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import { OutOfPageAd } from "../isomorphic/components/ads";
import DesktopHeaderAd from "../isomorphic/components/layouts/header/header-ad";

export function preRenderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  // const breakingNewsConfig = get(store.getState(), ["qt", "config", "publisher-attributes", "breaking_news"], {});
  const pageType = get(store.getState(), ["qt", "pageType"], null);
  // const breakingNewsInterval =
  //   breakingNewsConfig.interval && breakingNewsConfig.interval <= 60 ? 60 : breakingNewsConfig.interval;
  // const breakingNewsbaseProps = {
  //   hydrate,
  //   updateInterval: breakingNewsInterval * 1000
  // };

  if (pageType !== PAGE_TYPE.USER_LOGIN && pageType !== PAGE_TYPE.SUBSCRIPTION_PAGE && pageType !== PAGE_TYPE.SUBSCRIBE_PAGE && pageType !== PAGE_TYPE.PROFILE_PAGE) {
    renderComponent(Footer, "footer", store, hydrate);
    renderComponent(Header, "topbar", store, hydrate);
    // renderComponent(NavbarSearch, "search-bar", store, hydrate);
    if (document.getElementById("desktop-ad")) {
      renderComponent(DesktopHeaderAd, "desktop-ad", store);
    }
    if (document.getElementById("out-of-page-ad")) {
      renderComponent(OutOfPageAd, "out-of-page-ad", store);
    }
    // breakingNewsConfig.is_enable &&
    //   pageType !== "profile-page" &&
    //   renderBreakingNews("breaking-news-container", store, BreakingNewsView, breakingNewsbaseProps);
  }
  
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  global.qtConfig = store && store.getState().qt.config;

  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell
  });
}
